import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import Tooltip from '@mui/material/Tooltip/Tooltip';

import {CrossIcon} from '@/app/shared-components/CrossIcon/CrossIcon';

import '../styles';

interface IFilePreviewProps {
  preview: string | null;
  onRemove: () => void;
  filename: string | null;
}

export const FilePreview = ({
  preview,
  onRemove,
  filename,
}: IFilePreviewProps) => {
  if (!preview) return null;
  const isImage = preview.startsWith('data:');
  const isPdf = preview.toLowerCase().endsWith('.pdf');

  return (
    <Tooltip
      title={filename}
      arrow>
      <div className="file-preview">
        {isImage ? (
          <img
            src={preview}
            alt="preview"
            className="preview-image"
          />
        ) : (
          <>
            {isPdf && <PictureAsPdfIcon style={{color: 'red'}} />}
            <span className="file-name">{preview}</span>
          </>
        )}
        <button
          className="remove-preview-button"
          onClick={onRemove}>
          <CrossIcon />
        </button>
      </div>
    </Tooltip>
  );
};
